import type { PlaybackSnapshot } from '@/lib/audio/engine'

import { useSyncExternalStore } from 'react'
import { audioEngine } from '@/lib/audio/engine'

export const usePlayback = (): PlaybackSnapshot => {
    return useSyncExternalStore(audioEngine.subscribe, audioEngine.getSnapshot, audioEngine.getServerSnapshot)
}
